import { ReactNode } from "react";
import { cn } from "../utls/utils";

export interface InfoRowProps {
  /**
   * Label displayed in the leading column.
   */
  label: ReactNode;
  /**
   * Value displayed in the trailing column.
   */
  value: ReactNode;
  /**
   * Optional supporting visual placed before the label (icon, badge, etc.).
   */
  icon?: ReactNode;
  /**
   * When true, the value is allowed to wrap instead of truncating.
   */
  allowWrap?: boolean;
  /**
   * Additional classes for the outer container.
   */
  className?: string;
  /**
   * Additional classes for the label element.
   */
  labelClassName?: string;
  /**
   * Additional classes for the value element.
   */
  valueClassName?: string;
}

const baseContainerClasses =
  "w-full py-3 border-b border-beige-200 last:border-b-0 sm:grid sm:grid-cols-12 sm:gap-4";
const baseLabelClasses =
  "sm:col-span-4 flex items-start gap-2 text-xs font-semibold uppercase tracking-wide text-terracotta-700";
const baseValueClasses =
  "sm:col-span-8 text-sm text-text-dark";

export function InfoRow({
  label,
  value,
  icon,
  allowWrap = false,
  className,
  labelClassName,
  valueClassName,
}: InfoRowProps) {
  return (
    <div className={cn(baseContainerClasses, className)}>
      <div className={cn(baseLabelClasses, labelClassName)}>
        {icon ? <span className="text-terracotta-500">{icon}</span> : null}
        <span className="leading-snug">{label}</span>
      </div>
      <div
        className={cn(
          baseValueClasses,
          allowWrap ? "whitespace-pre-wrap break-words" : "truncate sm:whitespace-normal",
          valueClassName
        )}
      >
        {value}
      </div>
    </div>
  );
}

export default InfoRow;
